import { useEffect, useState } from "react";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import { formatMoney } from "../../../utils/utils";
import useFundsRequestService from "../../../app/services/hooks/useFundsRequestService";
import useCheckingAccountService from "../../../app/services/hooks/useCheckingAccount";
import { CheckingAccountFilters } from "../../../app/models/CheckingAccount";
import WorkerFundsDataTable from "./tables/WorkerFundDataTable";



interface Props {
    checkingAccountsFilter: CheckingAccountFilters,
    setCheckingAccountsFilter: (fundsFilter: CheckingAccountFilters) => void
    setTravelExpenseCheckingAccountTotal: (total: number) => void;
    travelExpenseCheckingAccountTotal: number
}

const TravelExpensesCheckingAccountContainer = ({ 
    checkingAccountsFilter,
    setCheckingAccountsFilter,
    setTravelExpenseCheckingAccountTotal,
    travelExpenseCheckingAccountTotal
}: Props) => {

    const { getCheckingAccountTotalByWorker, 
        getCheckingAccountsByWorker,
        fetchingGetCheckingAccountTotalByWorker,
        fetchingGetCheckingAccountsByWorker } = useCheckingAccountService();

    const [travelExpenseCheckingAccounts, setTravelExpenseCheckingAccounts] = useState<any[]>([]);
    const [travelExpenseCheckingAccountRows, setTravelExpenseCheckingAccountRows] = useState(0);
    const [travelExpenseCheckingAccountShowDataTable, setTravelExpenseCheckingAccountShowDataTable] = useState<boolean>(false);


    useEffect(()=>{
        getCheckingAccountTotalByWorker(checkingAccountsFilter, {
            onSuccess: (response: ServiceResponse) => {
                setTravelExpenseCheckingAccountTotal(response.data.totals)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        })
    },[checkingAccountsFilter]);

    useEffect(()=>{
        if(travelExpenseCheckingAccountShowDataTable){
            getCheckingAccountsByWorker(checkingAccountsFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTravelExpenseCheckingAccountRows(response.data.total_rows)
                    setTravelExpenseCheckingAccounts(response.data.checking_accounts)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    },[checkingAccountsFilter, 
        travelExpenseCheckingAccountShowDataTable, 
        checkingAccountsFilter.page, 
        checkingAccountsFilter.per_page
    ]);

    const showDataTable = () => {
        setTravelExpenseCheckingAccountShowDataTable(!travelExpenseCheckingAccountShowDataTable)
    }



    return (
        <>
           {/* <div className="row justify-content-start"> */}
            
                {/* FONDOS POR RENDIR*/}
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#C2AAAA',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showDataTable}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium" style={{ userSelect: 'none' }}>Viáticos por rendir</p>
                                {fetchingGetCheckingAccountTotalByWorker ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(travelExpenseCheckingAccountTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {travelExpenseCheckingAccountShowDataTable &&                
                    <div className="col-lg-10 mb-4">
                        <div className="h5">Detalle Fondos por Rendir</div>
                        <WorkerFundsDataTable 
                            data={travelExpenseCheckingAccounts}
                            progressPending={fetchingGetCheckingAccountsByWorker}
                            totalRows={travelExpenseCheckingAccountRows}
                            filter={checkingAccountsFilter}
                            setFilter={setCheckingAccountsFilter}
                        />
                    </div>
                }

           {/* </div> */}
        </>
    )

}

export default TravelExpensesCheckingAccountContainer;